import axios from '@/plugins/axios';
import { API_G_070_HAMBAI_YOSOKU_CONFIRM } from '@/constants/api';
import { removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

/* eslint-disable @typescript-eslint/no-explicit-any */
export type HambaiYosokuConfirm = {
  list: any;
};

const g_070: Module<HambaiYosokuConfirm, unknown> = {
  namespaced: true,
  state() {
    return {
      list: [],
    };
  },
  mutations: {
    SET_LIST(state, payload: []) {
      state.list = payload;
    },
    RESET_DATA(state) {
      state.list = [];
    },
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    //----------------------------------------
    // クリア
    //----------------------------------------
    resetData({ commit }) {
      commit('RESET_DATA');
    },
    //----------------------------------------
    // 年月取得
    //----------------------------------------
    async getNengetsu(_ctx, params) {
      try {
        // 年月取得
        const res = await axios({
          url: `${API_G_070_HAMBAI_YOSOKU_CONFIRM}/nengetsu`,
          params,
          method: 'GET',
        });
        return await Promise.resolve(res);
      } catch (err) {
        return await Promise.reject(err);
      }
    },
    //----------------------------------------
    // 一覧取得
    //----------------------------------------
    async getList({ dispatch, commit }, params) {
      // ローディングON
      dispatch('common/setIsLoading', true, { root: true });
      
      // 販売予測確認_公開用API.一覧取得
      const res = await axios({
        url: API_G_070_HAMBAI_YOSOKU_CONFIRM,
        params: removeBlankOrNullOrZero(params),
        method: 'GET',
      });
      
      // キーとなるIDをセット
      let retList = [];
      if (res.data.responseData && res.data.responseData.list.length > 0)
        retList = res.data.responseData.list.map(
          (item: any, index: any) => {
            return { id: index, ...item };
          }
        );
      commit('SET_LIST', retList);

      // ローディングOFF
      dispatch('common/setIsLoading', false, { root: true });
      return res;
    },
  },
};

export default g_070;
